export const removeEmptyValues = <T extends object>(object: T): T =>
  Object.fromEntries(
    Object.entries(object).filter(([_, value]) => value !== '' && value != null)
  ) as T;
